import { css } from '@emotion/react';
import { semantic_colors, colors, text_styles, shapes } from '../../foundation';

export const pagination_base_css = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const pagination_item_css = css`
  display: inline-block;
  list-style: none;
  text-align: center;
  vertical-align: middle;
`;

export const pagination_button_css = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  white-space: nowrap;
  border: 1px solid transparent;
  background-color: transparent;
  padding: 0;
  ${text_styles.Body_13_Regular};
  ${shapes.border_radius.small};
  transition: all 0.1s linear;

  &:focus {
    outline: 3px solid ${semantic_colors.tab_focus};
    box-shadow: none;
  }
  &:focus:not(:focus-visible) {
    outline: none;
  }
`;

export const pagination_button_default_style = {
  'color': semantic_colors.content.primary,
  '&:hover': {
    backgroundColor: `${colors.gray20}`,
    color: `${semantic_colors.content.primary}`,
  },
  '&:active': {
    backgroundColor: `${colors.gray30}`,
    color: `${semantic_colors.content.primary}`,
  },
};

export const pagination_button_disabled_style = {
  'color': semantic_colors.content.disabled,
  '&:hover, &:active': {
    backgroundColor: semantic_colors.background.surface,
    color: `${semantic_colors.content.disabled}`,
  },
};

export const pagination_button_selected_style = {
  'backgroundColor': semantic_colors.accent.primary,
  'color': semantic_colors.content.primary_inverse,
  '&:hover, &:active': {
    backgroundColor: `${semantic_colors.accent.primary}`,
    color: `${semantic_colors.content.primary_inverse}`,
  },
};

export const pagination_button_selected_disabled_style = {
  'backgroundColor': semantic_colors.content.disabled,
  'color': semantic_colors.content.primary_inverse,
  '&:hover, &:active': {
    backgroundColor: `${semantic_colors.content.disabled}`,
    color: `${semantic_colors.content.primary_inverse}`,
  },
};
